<template>
  <v-container class="fill-height" fluid>
    <v-row class="d-flex align-center">
      <v-col class="d-none d-sm-block text-center">
        <div>
          <v-btn color="success" href="https://panel.negarshowroom.com" width="250" x-large target="_blank">
            ورود به پنل کاربری
          </v-btn>
        </div>
        <div>
          <v-btn color="secondary" href="https://demo.negarshowroom.com" style="margin-top: 20px;" width="250" x-large
                 target="_blank">
            مشاهده دمو
          </v-btn>
        </div>
      </v-col>
      <v-col class="text-center d-sm-none d-block">
        <div>
          <v-btn color="success" href="https://panel.negarshowroom.com" width="100%" target="_blank">ورود به پنل
            کاربری
          </v-btn>
        </div>
        <div>
          <v-btn color="secondary" href="https://demo.negarshowroom.com" style="margin-top: 20px;" width="100%"
                 target="_blank">
            مشاهده دمو
          </v-btn>
        </div>
        <div>
          <v-btn :to="{ name: 'ContactUs'}" style="margin-top: 20px;" width="100%">تماس با ما</v-btn>
        </div>
      </v-col>

      <v-col class="text-center">
        <v-img :src="require('../assets/icon.svg')" contain height="200" transition="scale-transition"></v-img>
        <h1 class="white--text" style="position:relative;overflow: hidden">نرم‌افزار چیدمان نگار</h1>
      </v-col>
    </v-row>

    <v-row style="padding-bottom: 50px">
      <v-col sm="6" offset-sm="3" xs="12">
        <v-card class="main-card">
          <v-card-text>
            نرم‌افزار حرفه‌ای چیدمان نگار، با مدرن‌ترین تکنولوژی‌های برنامه‌نویسی نوشته شده و در سه بخش وب اپ، اپ
            اندروید و اپ iOS فعال است. این نرم‌افزار می‌تواند به صورت کاملا واقعی و رئال چیدمان کاشی، سرامیک، کاغذ
            دیواری، سنگ، آجرنما و ... را انجام دهد.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="d-none d-sm-block" style="z-index: 10; padding-bottom: 50px;">
      <v-col class="text-center">
        <v-btn :to="{ name: 'ContactUs'}">تماس با ما</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
}
</script>
